const Mutations = Object.freeze({
	SET_ENTITIES: 'activityBuilder/activityDetails/SET_ENTITIES',
	SET_SELECTED_ACTIVITY:
		'activityBuilder/activityDetails/SET_SELECTED_ACTIVITY',
	SET_CONDITION_FIELDS_LIST:
		'activityBuilder/activityDetails/SET_CONDITION_FIELDS_LIST',
	SET_GRID_VIEW_FIELDS:
		'activityBuilder/activityDetails/SET_GRID_VIEW_FIELDS',
	SET_HAS_ITEMS: 'activityBuilder/activityDetails/SET_HAS_ITEMS',
});

export const Actions = Object.freeze({
	CLEAR: 'activityBuilder/activityDetails/CLEAR',
	LOAD: 'activityBuilder/activityDetails/LOAD',
	LOAD_GRID_VIEW_FIELDS:
		'activityBuilder/activityDetails/LOAD_GRID_VIEW_FIELDS',
	INSERT_ACTIVITY: 'activityBuilder/activityDetails/INSERT_ACTIVITY',
	INSERT_CONDITION_FIELDS:
		'activityBuilder/activityDetails/INSERT_CONDITION_FIELDS',
	UPDATE_CONDITION_FIELDS:
		'activityBuilder/activityDetails/UPDATE_CONDITION_FIELDS',
	UPDATE_ACTIVITY: 'activityBuilder/activityDetails/UPDATE_ACTIVITY',
	DELETE: 'activityBuilder/activityDetails/DELETE',
	DELETE_ALL_ACTIVITY_ITEMS_BY_ID:
		'activityBuilder/activityDetails/DELETE_ALL_ACTIVITY_ITEMS_BY_ID',
});

export const Getters = Object.freeze({
	SELECTED_ACTIVITY: 'activityBuilder/activityDetails/SELECTED_ACTIVITY',
	ENTITIES: 'activityBuilder/activityDetails/ENTITIES',
	GRID_VIEW_FIELDS: 'activityBuilder/activityDetails/GRID_VIEW_FIELDS',
	GROUP_BY_FIELDS: 'activityBUilder/activityDetails/GROUP_BY_FIELDS',
	CONDITION_FIELDS_LIST:
		'activityBuilder/activityDetails/CONDITION_FIELDS_LIST',
	HAS_ITEMS: 'activityBuilder/activityDetails/HAS_ITEMS',
});
import { GeneralActions } from '../../../../actions';
import dataService from '../../../../../services/data/activityDataService';
export default {
	state: {
		entities: [],
		selectedActivity: null,
		gridViewFields: [],
		conditionFieldsList: [],
		hasItems: false,
	},
	mutations: {
		[Mutations.SET_ENTITIES](state, items) {
			state.entities = items;
		},
		[Mutations.SET_SELECTED_ACTIVITY](state, item) {
			state.selectedActivity = item;
		},
		[Mutations.SET_GRID_VIEW_FIELDS](state, items) {
			state.gridViewFields = items;
		},
		[Mutations.SET_CONDITION_FIELDS_LIST](state, items) {
			state.conditionFieldsList = items;
		},
		[Mutations.SET_HAS_ITEMS](state, item) {
			state.hasItems = item;
		},
	},
	actions: {
		[Actions.CLEAR]({ commit }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_ENTITIES, []);
				commit(Mutations.SET_SELECTED_ACTIVITY, null);
				commit(Mutations.SET_GRID_VIEW_FIELDS, null);
				commit(Mutations.SET_CONDITION_FIELDS_LIST, []);
				commit(Mutations.SET_HAS_ITEMS, false);
				resolve();
			});
		},
		[Actions.LOAD]({ commit, dispatch }, id) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				let promises = [
					dataService.getGridViews().then((resp) => {
						commit(Mutations.SET_ENTITIES, resp.data);
					}),
				];
				if (id) {
					promises.push(
						dataService.getActivityById(id).then((resp) => {
							commit(Mutations.SET_SELECTED_ACTIVITY, resp.data);
						})
					);
					promises.push(
						dataService
							.getGridViewFieldsByActivityId(id)
							.then((resp) => {
								commit(
									Mutations.SET_GRID_VIEW_FIELDS,
									resp.data
								);
							})
					);
					promises.push(
						dataService.getActivityItems(id).then((resp) => {
							if (resp.data.length > 0)
								commit(Mutations.SET_HAS_ITEMS, true);
						})
					);
					promises.push(
						dataService
							.getGroupByConditionFieldList(id)
							.then((resp) => {
								commit(
									Mutations.SET_CONDITION_FIELDS_LIST,
									resp.data
								);
							})
					);
				}
				Promise.all(promises)
					.then(() => {
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					});
			});
		},
		[Actions.LOAD_GRID_VIEW_FIELDS]({ commit, dispatch }, id) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getGridViewFieldsByActivityId(id)
					.then((resp) => {
						commit(Mutations.SET_GRID_VIEW_FIELDS, resp.data);
						dispatch(GeneralActions.LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve(false);
					});
			});
		},
		[Actions.INSERT_ACTIVITY]({ commit, dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.insertActivity(item)
					.then((resp) => {
						commit(Mutations.SET_SELECTED_ACTIVITY, resp.data);
						dispatch(GeneralActions.LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve(false);
					});
			});
		},
		[Actions.INSERT_CONDITION_FIELDS]({ dispatch, state, commit }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.insertGroupByConditionFieldList(item)
					.then((resp) => {
						let conditionFieldsList = state.conditionFieldsList;
						conditionFieldsList.push(resp.data);
						commit(
							Mutations.SET_CONDITION_FIELDS_LIST,
							conditionFieldsList
						);
						dispatch(GeneralActions.LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve(false);
					});
			});
		},
		[Actions.UPDATE_CONDITION_FIELDS]({ dispatch, commit, state }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.updateGroupByConditionFieldList(item)
					.then(() => {
						let conditionFieldsList = JSON.parse(
							JSON.stringify(state.conditionFieldsList)
						);
						conditionFieldsList.splice(
							conditionFieldsList.findIndex(
								(x) => x.Id == item.Id
							),
							1,
							item
						);
						commit(
							Mutations.SET_CONDITION_FIELDS_LIST,
							conditionFieldsList
						);
						dispatch(GeneralActions.LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve(false);
					});
			});
		},
		[Actions.UPDATE_ACTIVITY]({ dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.updateActivity(item)
					.then(() => {
						dispatch(GeneralActions.LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve(false);
					});
			});
		},
		[Actions.DELETE]({ dispatch, commit, state }, id) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.deleteGroupByConditionFieldList(id)
					.then(() => {
						let conditionFieldsList = state.conditionFieldsList;
						conditionFieldsList.splice(
							conditionFieldsList.findIndex((x) => x.Id == id),
							1
						);
						commit(
							Mutations.SET_CONDITION_FIELDS_LIST,
							conditionFieldsList
						);
						dispatch(GeneralActions.LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve(false);
					});
			});
		},
		[Actions.DELETE_ALL_ACTIVITY_ITEMS_BY_ID]({ dispatch, commit }, id) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.deleteAllActivityItemsByActivityId(id)
					.then(() => {
						commit(Mutations.SET_HAS_ITEMS, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
	},
	getters: {
		[Getters.ENTITIES]: (state) => {
			return JSON.parse(JSON.stringify(state.entities));
		},
		[Getters.SELECTED_ACTIVITY]: (state) => {
			return state.selectedActivity;
		},
		[Getters.GRID_VIEW_FIELDS]: (state) => {
			return JSON.parse(JSON.stringify(state.gridViewFields));
		},
		[Getters.CONDITION_FIELDS_LIST]: (state) => {
			return JSON.parse(JSON.stringify(state.conditionFieldsList));
		},
		[Getters.GROUP_BY_FIELDS]: (state) => {
			if (!state.selectedActivity) return [];
			if (!state.selectedActivity.GridViewFieldIds) return [];
			return JSON.parse(
				JSON.stringify(state.selectedActivity.GridViewFieldIds)
			);
		},
		[Getters.HAS_ITEMS]: (state) => {
			return JSON.parse(JSON.stringify(state.hasItems));
		},
	},
};
